// (B) 플레인 Avatar — antd Avatar 대체(순수 시각). `.om-avatar`/`-circle`/`-square`/`-image` hook.
// base 시각은 styles/omwAvatar.css(antd CSS-in-JS 파리티). 소비처는 대부분 src(이미지) 사용.
import type { CSSProperties } from 'react'
import type { OmwAvatarProps } from '../api/OmwAvatar'
import { cx } from './cx'
import '../styles/omwAvatar.css'

const PRESET_SIZE = { small: 'om-avatar-sm', default: '', large: 'om-avatar-lg' } as const

export function PlainAvatar({
  src,
  icon,
  shape = 'circle',
  size = 'default',
  className,
  style,
  children,
}: OmwAvatarProps) {
  // 프리셋 크기는 CSS 클래스(소비처 SCSS override 존중), 숫자만 인라인.
  const isNumeric = typeof size === 'number'
  const sizeStyle: CSSProperties | undefined = isNumeric
    ? { width: size, height: size, lineHeight: `${size}px` }
    : undefined
  const hasImage = src != null && src !== ''
  return (
    <span
      className={cx(
        'om-avatar',
        shape === 'square' ? 'om-avatar-square' : 'om-avatar-circle',
        !isNumeric && PRESET_SIZE[size],
        hasImage && 'om-avatar-image',
        icon != null && !hasImage && 'om-avatar-icon',
        className,
      )}
      style={{ ...sizeStyle, ...style }}
    >
      {hasImage ? (
        <img className="om-avatar-img" src={src} alt="" />
      ) : icon != null ? (
        icon
      ) : (
        <span className="om-avatar-string">{children}</span>
      )}
    </span>
  )
}
